export default "__VITE_ASSET__BFR0YHAv__"